/**
 * High level router.
 *
 * Note: It's recommended to compose related routes in internal router
 * components (e.g: `src/app/modules/Auth/pages/AuthPage`, `src/app/BasePage`).
 */

import {FC, useContext} from 'react'
import {Routes, Route, BrowserRouter, Navigate} from 'react-router-dom'
import {PrivateRoutes} from './PrivateRoutes'
import {ErrorsPage} from '../modules/errors/ErrorsPage'
import {Logout, AuthPage, useAuth} from '../modules/auth'
import {App} from '../App'
import { DashboardWrapper } from '../pages/dashboard/DashboardWrapper'
import { Machines } from '../../Components/Views/Machines/Machines'
import { MenuTestPage } from '../pages/MenuTestPage'
import UserContext from '../../UserContext'

/**
 * Base URL of the website.
 *
 * @see https://facebook.github.io/create-react-app/docs/using-the-public-folder
 */
const {PUBLIC_URL} = process.env

const AppRoutes: FC = () => {
  const user= useContext(UserContext);
  const {currentUser} = useAuth()
  
  return (
    <BrowserRouter basename={PUBLIC_URL}>
      <Routes>
        <Route element={<App />}>
        {/* <Route path='error/*' element={<ErrorsPage />} /> */}
          <Route path='logout' element={<Logout />} />

          <Route path='menu-test' element={<MenuTestPage />} />
          {currentUser ? (
           <>
              <Route path='/*' element={<PrivateRoutes />} />

            </> 
          ) : (
            <>
              <Route path='auth/*' element={<AuthPage />} />
              <Route path='*' element={<Navigate to='/auth' />} />
            </>
          )} 
        </Route>
      </Routes>
    </BrowserRouter>
  )
}

export {AppRoutes}
